// NG 2
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// APP
import { AppConfig } from '../app.config';
import { AuthenticationService } from './authentication.service';


@Injectable()
export class AuthGuardService  implements CanActivate {

  constructor(private router: Router, private authService: AuthenticationService) { }
  
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {        

       let isLoggedIn = this.authService.isLoggedIn();      
        if (isLoggedIn === true) {            
            return true;
        }
        else {
            window.location.href = AppConfig.config.cpuiLogoutUrl;  //nycid 2.0 clear the DOITT session 
            //this.router.navigate([''], { queryParams: { returnUrl: state.url } });
            //return false;      
        }

    }

}
